<template>
<div>

  <section class="content">

      <!-- Default box -->
      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title">Center Day Shift List</h3>
           
          <div class="box-tools pull-right">
            <button type="button" class="btn btn-box-tool" data-widget="collapse" data-toggle="tooltip" title="" data-original-title="Collapse">
              <i class="fa fa-minus"></i></button>
            <button type="button" class="btn btn-box-tool" data-widget="remove" data-toggle="tooltip" title="" data-original-title="Remove">
              <i class="fa fa-times"></i></button>
          </div>
        </div>
        <div class="box-body">
          
         
         <div class="row">
        <div class="col-md-12">
          <!-- general form elements disabled -->
          <div class="card card-warning">
            <!-- /.card-header -->
            <div class="card-body">
              <form role="form">
                <div class="row">
                  <div class="col-sm-4">
                    <!-- text input -->

                    <div class="form-group">
                      <label>Select Branch <span class="red">*</span></label>
                      <select
                        v-model="form.branch_id"
                        name="branch_id"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('branch_id') }"
                      >
                        <option value="">Select Branch</option>
                        <option value="true">Agra</option>
                        <option value="false">Mathura</option>
                      </select>
                      <has-error :form="form" field="branch_id"></has-error>
                    </div>

                    <div class="form-group">
                      <button type="button" class="btn btn-success">
                        <i class="fa fa-eye"></i> SAVE RECORDS
                      </button>
                    </div>
                  </div>

                  <div class="col-sm-4">
                    <div class="form-group">
                      <label>Center <span class="red">*</span></label>
                      <select
                        v-model="form.collection_center_id"
                        name="collection_center_id"
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('collection_center_id'),
                        }"
                      >
                        <option value="">Select Center</option>
                        <option value="Addition">Sanjay Palace</option>
                        <option value="Deduction">Khandari</option>
                      </select>
                      <has-error
                        :form="form"
                        field="collection_center_id"
                      ></has-error>
                    </div>
                  </div>

                  <div class="col-sm-4">
                    <div class="form-group">
                      <label>New Day <span class="red">*</span></label>
                      <select
                        v-model="form.newDay"
                        name="newDay"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('newDay') }"
                      >
                        <option value="Sunday">Sunday</option>
                        <option value="Monday">Monday</option>
                        <option value="Tuesday">Tuesday</option>
                        <option value="Wednesday">Wednesday</option>
                        <option value="Thursday">Thursday</option>
                        <option value="Friday">Friday</option>
                        <option value="Saturday">Saturday</option>
                      </select>
                      <has-error :form="form" field="newDay"></has-error>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <!-- /.card-body -->
          </div>
          <!-- /.card -->
        </div>
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">Update Center Day Shift</h3>
            </div>
            <!-- /.card-header -->
            <div class="card-body table-sm">
              <vue-good-table
                :columns="columns"
                :rows="rows"
                styleClass="vgt-table condensed"
                :pagination-options="{
                  enabled: true,
                  perPage: 10,
                  perPageDropdown: [10, 20, 30],
                }"
                :search-options="{
                  enabled: true,
                  trigger: 'enter',
                }"
              >
                <template slot="table-row"> </template>
              </vue-good-table>
            </div>
            <!-- /.card-body -->
          </div>
          <!-- /.card -->
        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->
         
                
        </div>
        <!-- /.box-body -->
        <div class="box-footer">
          List of all Center Day Shift
        </div>
        <!-- /.box-footer-->
      </div>
      <!-- /.box -->

    </section>


</div>
</template>

<script>
export default {
  name: 'CenterDayShift',
  data () {
    return {
      form: new Form({
        id: '',
        collection_center_id: '',
        branch_id: '',
        oldDay: '',
        newDay: '',
        status: true
      }),
      columns: [
        {
          label: 'BRANCH',
          field: 'branch.name'
        },
        {
          label: 'CENTER',
          field: 'collection_center.name'
        },
        {
          label: 'OLD DAY',
          field: 'oldDay'
        },
        {
          label: 'NEW DAY',
          field: 'newDay'
        },
        {
          label: 'DATE',
          field: 'updated_at'
        }
      ],
      rows: []
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    loadData () {
      let loader = this.$loading.show()
      this.$axios
        .get('centerdayshift', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log(data.data)
          loader.hide()
          this.rows = data.data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  created () {
    this.loadData()
  }
}
</script>



// WEBPACK FOOTER //
// CenterDayShift.vue?61d225be